import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface TrendingArticle {
  id: number;
  category: string;
  date: string;
  title: string;
  description: string;
  image: string;
}

const trendingArticles: TrendingArticle[] = [
  {
    id: 1,
    category: "Platform & Campsite Updates",
    date: "2025.10.08",
    title: "Smart Monitoring Trial Completed at Hok Tau Reservoir",
    description: "Alpha AI and AFCD successfully completed a 7-day A-IoT trial to test solar-powered monitoring devices for real-time campsite management.",
    image: "https://placehold.co/600x400/e2e8f0/64748b?text=Smart+Monitoring"
  },
  {
    id: 2,
    category: "Platform & Campsite Updates",
    date: "2025.10.07",
    title: "New Trails Unlocked: Explore Two Fresh Campsites Near Plover Cove!",
    description: "Two new hiking and camping trails have opened with improved signage, safety zones, and live occupancy tracking.",
    image: "https://placehold.co/600x400/e2e8f0/64748b?text=New+Trails"
  },
  {
    id: 3,
    category: "Nature & Safety Alerts",
    date: "2025.10.06",
    title: "Wildlife Alert at Bride's Pool Area",
    description: "AFCD issued a temporary alert following repeated wild boar sightings near the Bride's Pool picnic site. Visitors are advised to stay cautious.",
    image: "https://placehold.co/600x400/e2e8f0/64748b?text=Wildlife+Alert"
  }
];

export const TrendingSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="px-4 sm:px-8 lg:px-16 xl:px-24 py-16 bg-white">
      <h2
        className="mb-8"
        style={{
          fontFamily: 'Poppins',
          fontSize: '48px',
          fontWeight: 700,
          color: '#000000'
        }}
      >
        Trending
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {trendingArticles.map((article) => (
          <div
            key={article.id}
            onClick={() => navigate(`/news/${article.id}`)}
            className="rounded-2xl overflow-hidden bg-white cursor-pointer hover:shadow-lg transition-shadow"
          >
            <div className="relative h-64">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3 mb-3">
                <span
                  className="px-3 py-1 bg-black rounded-full"
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '11px',
                    fontWeight: 500,
                    color: '#FFFFFF'
                  }}
                >
                  {article.category}
                </span>
                <span
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '12px',
                    fontWeight: 400,
                    color: '#667479'
                  }}
                >
                  {article.date}
                </span>
              </div>
              <h3
                className="mb-3"
                style={{
                  fontFamily: 'Poppins',
                  fontSize: '20px',
                  fontWeight: 700,
                  lineHeight: '28px',
                  color: '#000000'
                }}
              >
                {article.title}
              </h3>
              <p
                className="mb-4"
                style={{
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  color: '#667479'
                }}
              >
                {article.description}
              </p>
              <button
                className="flex items-center gap-2"
                style={{
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#000000'
                }}
              >
                Read more
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
